// Generic type for results with count structure
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
